module.exports = __webpack_public_path__ + "assets/img/60.97666bdf.svg";